import React from 'react';
import {Background, LoadingText} from './LoadingStyle.js';
import Spinner from './assets/spinner.gif';

export default () => {
  return (
    <Background>
      <LoadingText>AI Tutor 内存设置中！</LoadingText>
      <img src={Spinner} alt="加载中" width="5%" />
    </Background>
  );
};